<template>
	<!-- App -->
  <!--<div class="page rowBackgroundHomepage">-->
  <page-outline :title="$t('Webheader.my_bank_accounts_statements')">
    <template slot="pageContent">
    <b-row class="m-0 pb-3 showSmallScreenOnly no-gutters">
      <back-button :returnUrl="returnUrl"></back-button> 
    </b-row>
    <div v-if="isSmartphoneOS">
      <f7-searchbar class="search w-100 z-10"
        id="searchBankAccount"
        :cancel-link="$t('common.cncl')"
        search-list="#bank-list"
        :placeholder="$t('bank_accounts.srch_in_accnts')"
        @searchbar:search="onSearch"
        @searchbar:clear="onClear">
      </f7-searchbar>
    </div>

    <div class="showSmallScreenOnly" v-if="bankAccounts.length">
      <f7-fab class="leftfav button-fab bottomButton" @click="extractCSV()">
        <i class="fa-duotone fa-file-arrow-down"></i>
      </f7-fab>
    </div>

    <!--<div class="page-content">-->
      <div class="listPage">
        <b-row>
          <b-col class="d-flex justify-content-center">
            <f7-searchbar class="search filterTitle" v-if="!isSmartphoneOS"
              id="searchBankAccount"
              :cancel-link="$t('common.cncl')"
              search-list="#bank-list"
              :placeholder="$t('bank_accounts.srch_in_accnts')"
              @searchbar:search="onSearch"
              @searchbar:clear="onClear">
            </f7-searchbar>
          </b-col>
        </b-row>
        <b-row class="form-group showLargeScreenOnly mb-27px no-gutters">
          <back-button v-if="!isSmartphoneOS" :returnUrl="returnUrl"></back-button>
          <b-button v-if="bankAccounts.length" variant="primary" @click="extractCSV()">
            <i class="fa-light fa-upload"></i>
            <span class="d-none d-xl-inline">{{ $t('common.extract_csv') }}</span>
            <span class="d-xl-none">{{ $t(' .csv') }}</span>
          </b-button>
        </b-row>

        <div class="itemList">
          <div class="layoutSubtitle"></div>
          <f7-list class="searchbar-not-found">
            <f7-list-item title="Nothing found"></f7-list-item>
          </f7-list>
          <cm-bank-accounts-list-statement :bankAccounts="bankAccounts" :filterBy="filterBy"></cm-bank-accounts-list-statement>
        </div>
        <div class="toolbarPageBottomBlank"></div>
      </div>
    <!--</div>-->
  </template>
</page-outline>
  <!--</div>-->
</template>

<script>
import moment from 'moment'
import Vue from 'vue'

import backButton from '@/components/common/backButton.vue'

import BankAccountsListStatement from './CMBankAccountsPage/CMBankAccountsListStatement.vue'

import {formatIbanHidden, formatIbanUKHidden} from '@/helpers/format'

import PageOutline from '@/components/common/PageOutline.vue'


export default {
  name: 'ImportBankAccountReportList',
  components: {
    'back-button': backButton,
    'cm-bank-accounts-list-statement': BankAccountsListStatement,
    // 'cm-bank-import-report-list': BankAccountsImportReportList,
    'page-outline': PageOutline
  },
  data () {
    return {
      bankAccountSelected: '',
      bankAccounts: [],
      filterBy: '',
      returnUrl: '/bankAccounts/'
    }
  },
  created () {
    this.$bus.$emit('change-mobile-header', {
      backLink: true,
      navbarInnerStyle: 'justify-content:start;',
      navTitle: this.$i18n.t('Webheader.my_bank_accounts_statements'),
      returnUrl: '/bankAccounts/'
    })
    this.$bus.on('refresh-bank-accounts-list-statement', () => {
      this.bankAccounts = []
      this.bankAccounts = this.$engine.bankAccounts.get()
      this.bankAccountSelected = this.$engine.bankAccounts.getIbanStatment()
    })
    this.$bus.emit('refresh-bank-accounts-list-statement')
    this.bankAccounts = this.$engine.bankAccounts.get()
    this.bankAccountSelected = this.$engine.bankAccounts.getIbanStatment()
    /* Messages de log à décommenter pour déboguer les statements des ML
    console.log('bank accounts: ')
    console.log(this.bankAccounts) */
    for (var i in this.bankAccounts) {
      if (this.bankAccounts[i].balances !== undefined && this.bankAccounts[i].balances.length > 0) {
        /* TLV 07/01/2020
        * Pour chaque compte bancaire, les balances associées doivent être triées
        * de la plus ancienne à la plus récente (execution_date)
        */
        this.bankAccounts[i].balances.sort(function (date1, date2) {
          return (date1.execution_date < date2.execution_date) ? -1 : ((date1.execution_date > date2.execution_date) ? 1 : 0)
        })

        this.bankAccounts[i].initialAmount = this.bankAccounts[i].opbd_amount
        /* Pour les autres valeurs, on calc le remaining amount nous-mêmes par rapport à la valeur précédente */
        for (var k = 0; k < this.bankAccounts[i].balances.length; k++) {
          let priorIndex = k - 1
          if (k === 0) {
            /* printed_opbd_amount correspond à la valeur affichée à l'écran. A la première ligne, il s'agit de la valeur de opbd_amount */
            priorIndex = k
            this.bankAccounts[i].balances[priorIndex].printed_opbd_amount = this.bankAccounts[i].opbd_amount
            /* Messages de log à décommenter pour déboguer les statements des ML
            console.log('first opbd amount')
            console.log(this.bankAccounts[i].balances[priorIndex].printed_opbd_amount) */
          }
          let total = 0
          if (this.bankAccounts[i].balances[k].credit_debit_indicator === 'DBIT') {
            total = parseFloat(this.bankAccounts[i].balances[priorIndex].printed_opbd_amount) - parseFloat(this.bankAccounts[i].balances[k].amount)
          } else {
            /* Messages de log à décommenter pour déboguer les statements des ML
            console.log('opbd amount calc')
            console.log(this.bankAccounts[i].balances[priorIndex].printed_opbd_amount)
            console.log(this.bankAccounts[i].balances[k])
            console.log(this.bankAccounts[i].balances[k].amount) */
            total = parseFloat(this.bankAccounts[i].balances[priorIndex].printed_opbd_amount) + parseFloat(this.bankAccounts[i].balances[k].amount)
          }
          this.bankAccounts[i].balances[k].printed_opbd_amount = total.toFixed(2)
        }
      }
    }
  },
  computed: {
    isSmartphoneOS () {
      return this.$f7.device.os === 'android' || this.$f7.device.os === 'ios'
    },
    filteredBankAccounts () {
      let that = this
      let result = []
      if (this.filterBy) {
        for (var k in that.bankAccounts) {
          if (that.bankAccounts[k].name.toLowerCase().includes(this.filterBy.toLowerCase())) {
            result.push(that.bankAccounts[k])
          }
        }
        return result
      }

      return this.bankAccounts
    },
    getReport () {
      return this.report
    }
  },
  methods: {
    // Extraction CSV des statements
    extractCSV () {
      let lines = ''
      let extractedBankAccounts = this.filteredBankAccounts
      // Adaptation pour un IBAN. Reste à adapter au filtre de recherche
      if (this.bankAccountSelected !== '') {
        extractedBankAccounts = []
        for (var p in this.bankAccounts) {
          if (this.bankAccounts[p].iban.toLowerCase() === this.bankAccountSelected.toLowerCase()) {
            extractedBankAccounts.push(this.bankAccounts[p])
          }
        }
      }
      for (var account in extractedBankAccounts) {
        if (extractedBankAccounts[account].balances.length > 0) {
          lines += 'Account Name;IBAN;Date;End To End Id;Reference;Second Party Name;Value;Remaining Amount \r\n'
          lines += extractedBankAccounts[account].name + ';' + extractedBankAccounts[account].iban + ';' + Vue.filter('formatDate')(extractedBankAccounts[account].opbd_date) + ';;;;;' + extractedBankAccounts[account].initialAmount + '\r\n'
          for (var k = 0; k < extractedBankAccounts[account].balances.length; k++) {
            lines += extractedBankAccounts[account].name + ';' + extractedBankAccounts[account].iban + ';'
            lines += Vue.filter('formatDate')(extractedBankAccounts[account].balances[k].execution_date) + ';'
            lines += extractedBankAccounts[account].balances[k].end_to_end_id + ';'
            lines += extractedBankAccounts[account].balances[k].reference + ';'
            lines += extractedBankAccounts[account].balances[k].creditor_debtor_name + ';'
            if (extractedBankAccounts[account].balances[k].credit_debit_indicator === 'DBIT') {
              lines += '-'
            } else {
              lines += '+'
            }
            lines += extractedBankAccounts[account].balances[k].amount + ';'
            lines += extractedBankAccounts[account].balances[k].printed_opbd_amount + ';\r\n'
          }
          // Derniere ligne
          lines += extractedBankAccounts[account].name + ';' + extractedBankAccounts[account].iban + ';'
          lines += Vue.filter('formatDate')(extractedBankAccounts[account].balances[extractedBankAccounts[account].balances.length - 1].execution_date) + ';;;;;'
          lines += extractedBankAccounts[account].balances[extractedBankAccounts[account].balances.length - 1].printed_opbd_amount + '\r\n'
        }
      }

      const linkSource = 'data:text/csv;charset:utf-8;base64,' + btoa(lines)
      const downloadLink = document.createElement('a')
      let today = moment()
      var fileName = 'Statements' + today.unix() + '.csv'
      downloadLink.href = linkSource
      downloadLink.download = fileName
      downloadLink.click()
    },
    onSearch: function (query, found) {
      this.filterBy = query
    },
    onClear: function () {
      this.filterBy = ''
    },
    getClassStatus (value) {
      var color = ''
      if (value === 1) {
        color = 'icon-account-green-bank'
      } else {
        color = 'icon-account-red-bank'
      }
      return color
    },
    formatIban (iban, zone) {
      if (zone === 'UK') {
        return formatIbanUKHidden(iban)
      } else {
        return formatIbanHidden(iban)
      }
    }
  }
}
</script>

